import { debug } from '../../../utils/DebugUtil';
import { StopPingError } from './StopPingError';
import { ping } from './ping';
export const startPresencePing = userId => {
  let pingInterval;
  ping(userId).then(() => {
    pingInterval = setInterval(() => {
      ping(userId).catch(e => {
        // Stop retrying on this specific error, any other it's okay to retry
        if (e instanceof StopPingError) {
          clearInterval(pingInterval);
        }
      });
    }, 60000);
  }).catch(e => {
    debug('failed to start presence ping', e);
  });
};